export default __webpack_public_path__ + "static/media/worst-attribute.f83c44ac.svg";